module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "site-footer"
    }
  }, [_h('nav', {
    attrs: {
      "id": "footer-nav"
    }
  }, [_h('ul', [_h('li', [_h('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, ["Portfolio"])]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": "/about"
    }
  }, ["About Me"])]), " ", _h('li', [_h('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, ["Contact"])])])]), " ", _h('footer', ["\n    Copyright © 2016 • Rommel Santor\n  "])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57296efe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 51
// module chunks = 1